import { useParams } from 'react-router-dom';
import { useEffectAsync } from 'utils/useEffectAsync';
import TabNav from 'components/global/TabNav';
import { $detail, $view,$list } from 'signals/global.signals';
import { fetchAndSetDealData } from 'components/views/FounderDeal/_helpers/founderDeal.resolvers';
import FounderDealPipeline from 'components/views/FounderDeal/_components/FounderDealPipeline';
import withDismount from 'hocs/withDismount';
import PageTitle from 'components/global/PageTitle/PageTitle';
import { Button, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import FounderDealAddPipelineModal from 'components/views/FounderDeal/_components/FounderDealAddPipelineModal';
import FounderDealRemoveInvestorModal from 'components/views/FounderDeal/_components/FounderDealRemoveInvestorModal';
import FounderDealDetail from 'components/views/FounderDeal/_components/FounderDealDetail';
import FounderDealEditModal from 'components/views/FounderDeal/_components/FounderDealEditModal';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import FounderDealEditPipelineModal from 'components/views/FounderDeal/_components/FounderDealEditPipelineModal';
import ProgressCircle from 'components/global/ProgressCircle/ProgressCircle';
import FounderEditDealModal from 'components/views/FounderDeals/_components/FounderEditDealModal';
const EditDeal = () => {
  const { id } = useParams();

  useEffectAsync(async () => {
    await fetchAndSetDealData(id);
  });
  return (
    <>
      <PageTitle
        Buttons={(
          <>
            <Button
              className="text-white border-dark bg-dark me-8"
              variant="transparent"
              size="sm"
              onClick={() => handleShowModal('deal-add-investor', { ...$detail.value, dealName: $detail.value?.name || `Untitled Deal - ${$detail.value?.id}` })}
            >
              <FontAwesomeIcon icon={faPlus} className="me-8" size="sm" />
              Add Investor
            </Button>
            <Button
              className="text-white border-dark bg-dark"
              variant="transparent"
              size="sm"
              onClick={() => handleShowModal('founder-edit-deal', { ...$detail.value })}
            >
              <FontAwesomeIcon icon={faEdit} className="me-8" size="sm" />
              Edit Raise
            </Button>
          </>
        )}
      >
        {$view.value.isLoading ? (
          <>
            ...Loading
          </>
        ) : (
          <span>{$detail.value.name}</span>
        )}
      </PageTitle>
      <Row className="mb-24 pb-24 w-100">
        <Col lg={4}>
          <ProgressCircle
            total={$detail.value?.currentRaiseSize || 1}
            amount={$detail.value?.sumOfCommitted || 0}
            totalLabel="Total Raise"
            amountLabel="Commitments to Date"
          />
        </Col>
        <Col lg={4}>
          <ProgressCircle
            total={$detail.value?.currentRaiseSize || 1}
            amount={$detail.value?.sumOfInvested || 0}
            totalLabel="Total Raise"
            amountLabel="Investments to Date"
          />
        </Col>
      </Row>
      <TabNav
        tabs={['Details', 'Pipeline']}
        activeTab={$view.value.activeTab}
        TabComponents={[
          <FounderDealDetail />,
          <FounderDealPipeline />,
        ]}
        async
      />
      <FounderDealAddPipelineModal />
      <FounderDealEditPipelineModal />
      <FounderDealRemoveInvestorModal />
      {/* Why create a totally new modal and use that? */}
      {/* <FounderDealEditModal /> */}
      <FounderEditDealModal />
        
    </>
  );
};

export default withDismount(EditDeal);
